module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-lineup-shizuoka-2-4387b40c413d5c6f6a2248fc9ff589e7.png";